// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3901":"30471035","5260":"6603271c","9596":"7b76eaa8"}[chunkId] + ".chunk.css";
};